// eslint-disable-next-line import/prefer-default-export
export const MANDATE_LIST = '/:clientToken/mandates';
